import { cnpjValido } from "@/utils/CnpjUtils.js";

const campoObrigatorioDefault = (val) => (val && val.length > 0) || "Campo Obrigatório!";
const campoObrigatorioComboDefault = (val) => (!!val) || "Campo Obrigatório!";
const campoCPFDefault = (val) => (val && val.length === 11) || "Preencha um CPF válido!";
const campoCEPDefault = (val) => (val && val.length === 8) || "Preencha um CEP válido!";
const campoCNPJDefault = (val) => cnpjValido(val) || "Preencha um CNPJ válido!";
const campoTamanhoMaximo = (val) => (!val || val.length <= 200) || "Preencha no máximo 200 caracteres.";
const campoNumberInteiros = (val) => (val >= 0) || "Preencha um número válido!"
export const campoEmail = (val) => {
	const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (!regex.test(val)) {
		return "Preencha um E-mail válido!";
	}
	return true;
}

export const validarIdentificacaoEmpregador = {
	tipoIdentificacao: [campoObrigatorioDefault, campoTamanhoMaximo],
	numeroIdentificacao: (id) => [campoObrigatorioDefault, id === "CNPJ" ? campoCNPJDefault : campoCPFDefault, campoTamanhoMaximo],
	razaoSocial: [],
	logradouro: [campoObrigatorioDefault, campoTamanhoMaximo],
	numero: [campoObrigatorioDefault, campoTamanhoMaximo],
	bairro: [campoObrigatorioDefault, campoTamanhoMaximo],
	cep: [campoObrigatorioDefault, campoCEPDefault],
	uf: [campoObrigatorioComboDefault],
	tipoLogradouro: [campoObrigatorioComboDefault],
	cidade: [campoObrigatorioComboDefault],
	referenciaAcesso: [campoTamanhoMaximo],
	telefone: [campoObrigatorioDefault, campoTamanhoMaximo],
	utilizaWhatsApp: [campoObrigatorioDefault, campoTamanhoMaximo],
	email: [campoObrigatorioDefault, campoEmail, campoTamanhoMaximo],
	responsavelSINE: [campoObrigatorioDefault, campoTamanhoMaximo],
	cargo: [campoObrigatorioDefault, campoTamanhoMaximo],
	outroContratante: [campoObrigatorioDefault, campoTamanhoMaximo],
	contratanteTipoIdentificacao: [campoObrigatorioDefault, campoTamanhoMaximo],
	contratanteNumeroIdentificacao: (id) => [campoObrigatorioDefault, id === "CNPJ" ? campoCNPJDefault : campoCPFDefault, campoTamanhoMaximo],
	contratanteRazaoSocial: [],
};

export const validarDadosVagas = {
	ocupacao: [campoObrigatorioComboDefault],
	cbo: [campoObrigatorioComboDefault],
	numeroVagas: [campoNumberInteiros],
	salarioMensal: [campoObrigatorioDefault],
	descricaoAtividades: [campoObrigatorioDefault, (val) => (val.length <= 300) || "Preencha no máximo 300 caracteres."],
	logradouro: [campoObrigatorioDefault],
	bairro: [campoObrigatorioDefault],
	cep: [campoObrigatorioDefault, campoCEPDefault],
	uf: [campoObrigatorioComboDefault],
	tipoLogradouro: [campoObrigatorioComboDefault],
	cidade: [campoObrigatorioComboDefault],
	referenciaAcesso: [campoTamanhoMaximo],
	enderecoTrabalhoIgual: [campoObrigatorioDefault],
	horarioTrabalho: [campoObrigatorioDefault, campoTamanhoMaximo],
	pcd: [campoObrigatorioDefault],
	periodoContratacao: [campoNumberInteiros],
	tipoContratacao: [campoObrigatorioDefault],
	instituicao: [campoObrigatorioDefault, campoTamanhoMaximo],
	nomeCurso: [campoObrigatorioDefault, campoTamanhoMaximo],
	dataInicioCurso: [campoObrigatorioDefault],
	cargaHorariaTeoricaSemanal: [campoNumberInteiros],
	cargaHorariaPraticaSemanal: [campoNumberInteiros],
	insalubridade: [campoNumberInteiros],
	periculosidade: [campoNumberInteiros],
	outros: [campoObrigatorioDefault, campoTamanhoMaximo],
	motivosContratacao: [campoObrigatorioDefault],
	agencia: [campoObrigatorioComboDefault],
};

export const validarRequisitos = {
	experienciaMeses: [campoObrigatorioComboDefault],
	comprovacaoCTPS: [campoObrigatorioDefault],
	escolaridadeMinima: [campoObrigatorioComboDefault],
	tipoHabilitacao: [campoObrigatorioComboDefault],
	observacoes: [campoObrigatorioDefault, (val) => (val.length <= 300) || "Preencha no máximo 300 caracteres."],
};

export const validarDadosEntrevista = {
	responsavel: [campoObrigatorioDefault, campoTamanhoMaximo],
	cargo: [campoObrigatorioDefault, campoTamanhoMaximo],
	dataEntrevista: [campoObrigatorioDefault],
	horarioEntrevista: [campoObrigatorioDefault],
	local: [campoObrigatorioDefault, campoTamanhoMaximo],
	dataRetorno: [campoObrigatorioDefault],
};

export const validarAgencias = {
	nome: [campoObrigatorioDefault, campoTamanhoMaximo],
	coordenador: [campoObrigatorioDefault, campoTamanhoMaximo],
	horarioFuncionamento: [campoObrigatorioDefault, campoTamanhoMaximo],
};

export const validarMovimentacoes = {
	observacoes: (obrigatorio) => [obrigatorio ? campoObrigatorioDefault : true, (val) => (!val || val.length >= 10) || "Preencha no minimo 10 caracteres!", (val) => (!val || val.length <= 1500) || "Preencha no máximo 1500 caracteres!"],
};
